import type { LinkMatcher } from '@lexical/react/LexicalAutoLinkPlugin';
import { AutoLinkPlugin } from '@lexical/react/LexicalAutoLinkPlugin';

/**
 * Explicit URLs only: `http(s)://`, then a host with at least one dot between non-empty labels.
 * - An optional port and path follow; trailing `.`, `,` or `;` is left as sentence punctuation.
 */
export const URL_PATTERN = /https?:\/\/[\p{L}\p{N}-]+(?:\.[\p{L}\p{N}-]+)+(?::\d+)?(?:[/?#](?:\S*[^\s.,;])?)?/u;

const urlMatcher: LinkMatcher = (text) => {
  const match = URL_PATTERN.exec(text);
  if (!match) return null;
  return {
    index: match.index,
    length: match[0].length,
    text: match[0],
    url: match[0],
    attributes: { target: '_blank', rel: 'noopener noreferrer' },
  };
};

const MATCHERS = [urlMatcher];

/** Turns typed or pasted URLs into links as you write. */
export const UrlAutoLinkPlugin = () => <AutoLinkPlugin matchers={MATCHERS} />;
